import type { TopologyEdgeSettings } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import {
  type GraphState,
  isTopologyProtocolSettings,
} from 'components/Graph/GraphState';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectTopologyPresetDraftOtherProtocols: (
  s: GraphState,
) => TopologyEdgeSettings[] = createScopedSelector(() =>
  createSelector(prop('layoutSettings', 'presetDraft', 'edges'), (edges) =>
    edges.filter(isTopologyProtocolSettings),
  ),
);
